import { Component, output } from '@angular/core';
import { Icon } from '../../icon/icon.component';

@Component({
    selector: 'app-name-tag',
    template: `
        <div class="flex items-center gap-1 px-2 py-1 rounded-lg w-max">
            <p class="text-xs">
                <ng-content />
            </p>
            <app-icon name="material-symbols:close" (click)="emit.emit()" />
        </div>
    `,
    standalone: true,
    imports: [Icon],
})
export class NameTag {
    emit = output<void>();
}
